/* eslint-disable no-magic-numbers */
export const IS_E2E =
  !!(window as Window & { Cypress?: unknown }).Cypress &&
  process.env.ENVIRONMENT !== 'staging';

export const AUTH0_LOCALSTORAGE = 'auth0Cypress';
export const AUTH0_ROLES = 'http://omniplatform.com/roles';
export const AUTH0_USERID = 'https://app.omnipresent.com/user_id';

export enum HTTPStatusCodes {
  OK = 200,
  RESOURCE_CREATED = 201,
  ACCEPTED = 202,
  NO_CONTENT = 204,
  MULTI_STATUS = 207,
  MOVED_PERMANENTLY = 301,
  TEMPORARY_REDIRECT = 307,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  CONFLICT = 409,
  GONE = 410,
  PRECONDITION_FAILED = 412,
  UNSUPPORTED_MEDIA_TYPE = 415,
  UNPROCESSABLE = 422,
  SERVER_ERROR = 500,
  BAD_GATEWAY = 502,
  SERVICE_UNAVAILABLE = 503,
  TOO_MANY_REQUESTS = 429,
}

export enum HTTPMethods {
  CONNECT = 'CONNECT',
  DELETE = 'DELETE',
  GET = 'GET',
  HEAD = 'HEAD',
  OPTIONS = 'OPTIONS',
  PATCH = 'PATCH',
  POST = 'POST',
  PUT = 'PUT',
  TRACE = 'TRACE',
}
